// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1328":"0ad9110c1c5c6f3e","5364":"2c965e64095eff02","6061":"16b286d4b4923b3e","7631":"79d23381fbc3dcc5"}[chunkId] + ".css";
};